import { render } from "./DiffActionHeadline.vue?vue&type=template&id=a50a8c00"
import script from "./DiffActionHeadline.vue?vue&type=script&lang=js"
export * from "./DiffActionHeadline.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src710843524/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__